import { PrincipalFormFields, PrincipalDTO } from 'types';

export const parsePrincipalDTOIntoPrincipalFormFields: (
    principalDTO: PrincipalDTO,
) => PrincipalFormFields = (principalDTO) => ({
    name: principalDTO.name || '',
    teacherId: principalDTO.employee?.id,
    selectFromTeacherList: !principalDTO.name,
});
